function FinishedCampaignsController(
    $scope,
    $filter,
    $uibModal,
    PermissionService,
    CampaignsService,
    LocalisationService,
    ErrorService,
    notify,
    $state,
    NgTableParams,
    NgTableEventsChannel,
    DashboardConfig
) {
    const self = this;

    /**
     * Initialises the controller and sets up the scope variables, permissions and grids
     */
    self.initialise = function () {
        self.userContext = PermissionService.userContext;

        $scope.search = ''
        $scope.$watch('search', (value) => {
            $scope.campaignsTableParams.filter({ query: value || '' });
            $scope.campaignsTableParams.reload();
        });

        if (!self.userContext) {
            return;
        }

        $scope.contextName = self.userContext.getCurrentContextName();

        // Check if the user has access to view the Campaigns page
        checkUserAccessToCampaignManagement();
        NgTableEventsChannel.onPagesChanged(
            () => document.querySelector("body")
                .scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                }),
            $scope
        );
        setupTable();
    };

    /**
     * Check if the user has access to view the Users page
     */
    function checkUserAccessToCampaignManagement() {
        const userCanManageCampaigns = PermissionService
            .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ManageCampaigns,
                self.userContext);

        if (!userCanManageCampaigns) {
            PermissionService.navigateToAccessDenied();
        }
    }

    function setupTable() {
        let isRequestInProgress = false;
        $scope.campaignsTableParams = new NgTableParams(
            {
                filterDelay: 300
            }, {
                getData: async (params) => {
                    if (isRequestInProgress) return; // Skip if already in progress
                    $scope.$root.isLoading = true;
                    isRequestInProgress = true;
                    const { query } = params.filter();
                    const { page, count } = params.url();
                    try {
                        const response = await CampaignsService.getCompletedCampaigns(
                            self.userContext.StoreId,
                            self.userContext.BrandId,
                            page,
                            count,
                            query ? query : null
                        );
                        const { Campaigns, TotalCount } = response.data;
                        Dashboard.helpers.tableHelper.useCount(params, TotalCount);
                        return Campaigns.map(item =>
                            new Dashboard.Models.Campaign()
                                .initialiseCampaignList(item, LocalisationService)
                        );
                    } catch (e) {
                        ErrorService.showError("An error occurred when loading the campaigns", e);
                    } finally {
                        isRequestInProgress = false;
                        $scope.$root.isLoading = false;
                    }
                }
            });
    }

    $scope.getReportioUrl = function (campaign) {
        let reportioParams = self.userContext.StoreId
            ? DashboardConfig.ReportioStoreCampaignReportParams
            : DashboardConfig.ReportioBrandCampaignReportParams;
        const contextId = self.userContext.StoreId
            ? self.userContext.StoreId
            : self.userContext.BrandId;

        reportioParams = reportioParams.format(
            LocalisationService.formatDateTime(
                campaign.StartDate,
                DashboardConfig.ReportioUrlDateFormat
            ),
            LocalisationService.formatDateTime(
                campaign.EndDate,
                DashboardConfig.ReportioUrlDateFormat
            ),
            contextId,
            campaign.Id
        );
        return DashboardConfig.ReportioUrl + reportioParams;
    };

    $scope.cancelCampaign = function (campaign) {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'components/campaigns/cancelcampaign/cancelcampaignmodal.7d64b189.html',
            controller: 'CancelCampaignModalController',
            backdrop: 'static',
            resolve: {
                campaign: function () {
                    return campaign;
                }
            }
        });

        modalInstance.result.then(function (result) {
            if (!result) {
                return;
            }
            CampaignsService.cancelCampaign(campaign.Id).then(function () {
                setupTable();
                notify.success('The campaign was successfully cancelled');
            }, function error(result) {
                ErrorService.showError('An error occurred when attempting to cancel a campaign', result);
            })
        })

    };

    self.initialise();
}

angular
    .module("dashboard")
    .component("finishedCampaigns",
        {
            templateUrl: "components/campaigns/finishedcampaigns/finishedcampaigns.4e387db1.html",
            bindings: {},
            controller: [
                "$scope",
                "$filter",
                '$uibModal',
                "PermissionService",
                "CampaignsService",
                "LocalisationService",
                "ErrorService",
                "notify",
                "$state",
                "NgTableParams",
                'ngTableEventsChannel',
                "DashboardConfig",
                FinishedCampaignsController ]
        });
